import { api, startLoading, endLoading } from '@/api'
import * as types from './types'

export default {
  /**
  * Get all users by location
  * @param {Object} params - SearchOptions object
  */
  async getUsersByLocation ({ commit, dispatch }, params) {
    let loaderName = 'getUsersByLocation'
    startLoading(dispatch, loaderName)

    return new Promise((resolve, reject) => {
      api
        .getUsersByLocation(params)
        .then((response) => {
          commit(types.SET_USERS, response.data.items)
          endLoading(dispatch, loaderName)
          resolve(response.data.count)
        })
        .catch((error) => {
          endLoading(dispatch, loaderName)
          reject(error)
        })
    })
  },
  /**
  * Get roles based on user
  */
  async getRoles ({ commit, dispatch }) {
    let loaderName = 'getRoles'
    startLoading(dispatch, loaderName)

    return new Promise((resolve, reject) => {
      api
        .getRoles()
        .then((response) => {
          commit(types.SET_ROLES, response.data)
          endLoading(dispatch, loaderName)
          resolve(response.data)
        })
        .catch((error) => {
          endLoading(dispatch, loaderName)
          reject(error)
        })
    })
  },
  /**
  * Create a new user
  * @param {Object} user - User's data
  */
  async createUser ({ commit, dispatch }, user) {
    let loaderName = 'createUser'
    startLoading(dispatch, loaderName)
    // Convert additional emails array into comma-delimiter string
    if (user.additionalEmailsArray.length > 0) {
      user.additionalEmails = user.additionalEmailsArray.map((ae) => ae.email).join(',')
    }
    return new Promise((resolve, reject) => {
      api
        .createUser(user)
        .then((response) => {
          // Note: If there's no data, it means that the user already exists
          if (response.data !== '') {
            commit(types.ADD_USER, response.data)
            resolve(response.data)
          } else {
            reject(new Error('We found an existing user with the email address provided.'))
          }
          endLoading(dispatch, loaderName)
        })
        .catch((error) => {
          endLoading(dispatch, loaderName)
          reject(error)
        })
        .then(() => {
          user.additionalEmails = []
        })
    })
  },
  /**
  * Update an existing user
  * @param {Object} user - User's data
  */
  async updateUser ({ commit, dispatch }, user) {
    let loaderName = 'updateUser'
    startLoading(dispatch, loaderName)
    // Convert additional emails array into comma-delimiter string
    if (user.additionalEmailsArray.length > 0) {
      user.additionalEmails = user.additionalEmailsArray.map((ae) => ae.email).join(',')
    }
    if (user.additionalLocationsArray.length > 0) {
      user.additionalLocations = user.additionalLocationsArray.map((al) => al.location).join(',')
    }
    return new Promise((resolve, reject) => {
      api
        .updateUser(user)
        .then((response) => {
          // Note: If there's no data, it means that the user already exists
          if (response.data === -1) {
            reject(new Error('We found an existing user with the email address provided.'))
          }
          if (response.data === 0) {
            reject(new Error('There was an error updating the user.'))
          } else {
            resolve(response.data)
          }
          endLoading(dispatch, loaderName)
        })
        .catch((error) => {
          endLoading(dispatch, loaderName)
          reject(error)
        })
        .then(() => {
          user.additionalEmails = []
        })
    })
  },
  /**
  * Delete an existing user
  * @param {Object} user - User's data
  */
  async deleteUser ({ commit, dispatch }, user) {
    let loaderName = 'deleteUser'
    startLoading(dispatch, loaderName)
    return new Promise((resolve, reject) => {
      api
        .deleteUser({ id: user.id })
        .then((response) => {
          commit(types.DELETE_USER, user)
          endLoading(dispatch, loaderName)
          resolve(response)
        })
        .catch((error) => {
          endLoading(dispatch, loaderName)
          reject(error)
        })
    })
  },
  /**
  * Get a user
  * @param {Number} userID - User's ID
  */
  async getUser ({ commit, dispatch }, userID) {
    let loaderName = 'getUser'
    startLoading(dispatch, loaderName)

    return new Promise((resolve, reject) => {
      api
        .getUser(userID)
        .then((response) => {
          if (response.data === '') {
            reject(new Error('User not found.'))
          } else {
            endLoading(dispatch, loaderName)
            resolve(response.data)
          }
        })
        .catch((error) => {
          endLoading(dispatch, loaderName)
          reject(error)
        })
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/user/actions.js